import { render } from "./tablesV2.vue?vue&type=template&id=2e87da7b&scoped=true&ts=true"
import script from "./tablesV2.vue?vue&type=script&lang=ts"
export * from "./tablesV2.vue?vue&type=script&lang=ts"

import "./tablesV2.vue?vue&type=style&index=0&id=2e87da7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e87da7b"]])

export default __exports__